/**
 * DPPA permissible uses, 18 U.S.C. §2721(b), keyed the way they are stored on a client
 * (Client.MvrDppaPermissibleUse, e.g. "(b)(3)").
 *
 * The MVR page used to label every client's use "Legitimate Business Use". Each lookup now goes to the
 * state under the client's own use (OP#176), so the page names the use actually on file.
 */
const DPPA_USE_LABELS: Record<string, string> = {
  '(b)(1)': 'Government Agency Use',
  '(b)(2)': 'Motor Vehicle or Driver Safety and Theft',
  '(b)(3)': 'Legitimate Business Use',
  '(b)(4)': 'Court and Legal Proceedings',
  '(b)(5)': 'Research and Statistical Reports',
  '(b)(6)': 'Insurance',
  '(b)(7)': 'Towed or Impounded Vehicle Notice',
  '(b)(8)': 'Licensed Private Investigation',
  '(b)(9)': 'Employer Verification of CDL Information',
  '(b)(10)': 'Private Toll Transportation Facility',
  '(b)(11)': 'Individual Requests (Opt-In)',
  '(b)(12)': 'Bulk Distribution (Opt-In)',
  '(b)(13)': 'Written Consent of the Individual',
  '(b)(14)': 'Use Authorized by State Law',
};

/** "§(b)(3) — Legitimate Business Use"; an unrecognised code is shown as stored rather than guessed at. */
export const formatDppaUse = (code: string): string => {
  const label = DPPA_USE_LABELS[code.trim()];
  return label ? `§${code} — ${label}` : `§${code}`;
};
